import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timeout = null
  }

  submit() {
    this.element.requestSubmit()
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300)
  }

  reset(event) {
    event.preventDefault()
    this.element.querySelectorAll("input, select").forEach(el => {
      if (el.type === "text" || el.type === "search") el.value = ""
      if (el.tagName === "SELECT") el.selectedIndex = 0
    })
    this.element.requestSubmit()
  }
}
